import { render, staticRenderFns } from "./properties-block-list-item.vue?vue&type=template&id=9f7d3832&scoped=true"
import script from "./properties-block-list-item.vue?vue&type=script&lang=js"
export * from "./properties-block-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7d3832",
  null
  
)

export default component.exports